import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";


export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  const scrollTo = (id: string) => {
    setMenuOpen(false);
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 300);
    } else {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  const navItems = [
    { label: "Ürün", id: "urun-nedir" },
    { label: "Teknik Yapı", id: "teknik-yapi" },
  ];

  const scrollToCatalog = () => {
    setMenuOpen(false);
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const el = document.getElementById("katalog");
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 300);
    } else {
      const el = document.getElementById("katalog");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <nav className="fixed top-0 left-0 w-full z-50 bg-white/80 backdrop-blur-md border-b border-gray-100">
        <div className="max-w-[1200px] mx-auto px-6 flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              src="https://static.readdy.ai/image/ecb21a4bf5131aa1974d0073377f0964/747df155e81b0da5fc194fc4a2f96f93.png"
              alt="AKSESS Logo"
              className="h-8 md:h-10 w-auto object-contain"
            />
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollTo(item.id)}
                className="text-sm font-medium tracking-wide text-[#2B2B2B] hover:text-[#A66A3F] transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </button>
            ))}
            <Link
              to="/karsilastirma"
              className="text-sm font-medium tracking-wide text-[#2B2B2B] hover:text-[#A66A3F] transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              Karşılaştır
            </Link>
            <Link
              to="/hakkimizda"
              className="text-sm font-medium tracking-wide text-[#2B2B2B] hover:text-[#A66A3F] transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              Hakkımızda
            </Link>
            <button
              onClick={scrollToCatalog}
              className="inline-flex items-center gap-1.5 text-sm font-medium px-4 py-2 bg-[#2B2B2B] text-white hover:bg-[#A66A3F] transition-all duration-200 cursor-pointer whitespace-nowrap rounded-md"
            >
              <i className="ri-book-open-line text-sm" />
              Katalog
            </button>
            <Link
              to="/iletisim"
              className="text-sm font-medium px-5 py-2 border border-[#A66A3F] text-[#A66A3F] hover:bg-[#A66A3F] hover:text-white transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              İletişim
            </Link>
          </div>

          {/* Mobile Hamburger */}
          <button
            className="md:hidden flex flex-col gap-1.5 cursor-pointer p-2 z-50 relative"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menü"
          >
            <span className={`block w-6 h-0.5 bg-[#2B2B2B] transition-all duration-300 ${menuOpen ? "rotate-45 translate-y-2" : ""}`} />
            <span className={`block w-6 h-0.5 bg-[#2B2B2B] transition-all duration-300 ${menuOpen ? "opacity-0" : ""}`} />
            <span className={`block w-6 h-0.5 bg-[#2B2B2B] transition-all duration-300 ${menuOpen ? "-rotate-45 -translate-y-2" : ""}`} />
          </button>
        </div>
      </nav>

      {/* Mobile Overlay */}
      <div
        className={`fixed inset-0 z-40 bg-black/40 md:hidden transition-opacity duration-300 ${menuOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
        onClick={() => setMenuOpen(false)}
      />

      {/* Mobile Slide-in Menu (from right) */}
      <div
        className={`fixed top-0 right-0 h-full w-72 z-50 bg-white shadow-2xl md:hidden flex flex-col transition-transform duration-300 ease-in-out ${menuOpen ? "translate-x-0" : "translate-x-full"}`}
      >
        {/* Menu Header */}
        <div className="flex items-center justify-between px-6 h-16 border-b border-gray-100">
          <img
            src="https://static.readdy.ai/image/ecb21a4bf5131aa1974d0073377f0964/747df155e81b0da5fc194fc4a2f96f93.png"
            alt="AKSESS"
            className="h-7 w-auto object-contain"
          />
          <button
            onClick={() => setMenuOpen(false)}
            className="w-8 h-8 flex items-center justify-center text-[#2B2B2B] cursor-pointer"
            aria-label="Kapat"
          >
            <i className="ri-close-line text-xl" />
          </button>
        </div>

        {/* Menu Items */}
        <div className="flex flex-col px-6 py-8 gap-1 flex-1">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-sm font-medium text-[#2B2B2B] hover:text-[#A66A3F] text-left py-3 border-b border-gray-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
          <Link
            to="/karsilastirma"
            onClick={() => setMenuOpen(false)}
            className="text-sm font-medium text-[#2B2B2B] hover:text-[#A66A3F] py-3 border-b border-gray-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            Karşılaştır
          </Link>
          <Link
            to="/hakkimizda"
            onClick={() => setMenuOpen(false)}
            className="text-sm font-medium text-[#2B2B2B] hover:text-[#A66A3F] py-3 border-b border-gray-50 transition-colors cursor-pointer whitespace-nowrap"
          >
            Hakkımızda
          </Link>
          <Link
            to="/iletisim"
            onClick={() => setMenuOpen(false)}
            className="mt-4 text-center text-sm font-semibold px-5 py-3 bg-[#A66A3F] text-white hover:bg-[#8f5a33] transition-colors cursor-pointer whitespace-nowrap"
          >
            İletişim
          </Link>
          <button
            onClick={scrollToCatalog}
            className="mt-2 flex items-center justify-center gap-2 text-sm font-semibold px-5 py-3 bg-[#2B2B2B] text-white hover:bg-[#3a3a3a] transition-colors cursor-pointer whitespace-nowrap rounded-md"
          >
            <i className="ri-book-open-line text-sm" />
            Katalog
          </button>
        </div>

        {/* Menu Footer */}
        <div className="px-6 py-6 border-t border-gray-100">
          <p className="text-xs text-gray-400">© 2024 AKSESS Energy Systems</p>
        </div>
      </div>
    </>
  );
}
